import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles, Grow, ClickAwayListener } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import {
  ArrowDropDown,
  ArrowDropUp,
  ExpandLess,
  ExpandMore,
} from "@material-ui/icons";

// PROPS NEEDED
// options "Array of Strings",
// width "Number"
// maxWidth "Number"
// selectorHandle "Function to trigger on change"
// selectedOption "String"

function Selector2(props) {
  const {
    classes,
    options,
    selectedOption,
    selectorHandle,
    width,
    maxWidth,
    t,
    type,
  } = props;
  const [selectorOpen, toggleSelector] = useState(false);
  const [onSearch, setOnSearch] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [query, setQuery] = useState("");
  const inputRef = useRef();

  // window.addEventListener("click", function (e) {
  //   // e.stopPropagation();
  //   // if (onSearch) {
  //   //   return setOnSearch(false);
  //   // }

  //   toggleSelector(false);
  // });

  // useEffect(() => {
  //   if (!onSearch) {
  //     // setQuery("");
  //     // setFilteredOptions([]);
  //   }
  // }, [onSearch]);

  const handleOptionClick = (e, o) => {
    e.stopPropagation();
    toggleSelector(false);

    setOnSearch(false);
    selectorHandle(o);
  };

  const toggleSelectorHandle = (e) => {
    e.stopPropagation();
    let toggle = selectorOpen ? false : true;
    toggleSelector(toggle);
  };

  const filterOptions = (e) => {
    if (e.target.value === "") {
      setQuery("");
      return setFilteredOptions(options);
    }

    setQuery(e.target.value);

    let duplicatedOptions = options;
    let filtered = [];

    duplicatedOptions.map((o) => {
      if (
        o.toLowerCase().startsWith(e.target.value.toLowerCase()) ||
        o.toLowerCase().includes(e.target.value.toLowerCase())
      ) {
        filtered.push(o);
      }
    });

    setFilteredOptions(filtered);
  };

  const handleInputFocus = () => {
    setOnSearch(!onSearch);
  };

  if (type && type === "boolean") {
    return (
      <ClickAwayListener onClickAway={(e) => toggleSelector(false)}>
        <div
          style={{
            width: width,
            maxWidth: maxWidth,
            opacity: props.disabled ? 0.5 : 1,
          }}>
          {props.label ? <p className={classes.label}>{props.label}</p> : ""}
          <div className={classes.selector}>
            <div
              className="selected"
              onClick={
                props.disabled ? () => {} : (e) => toggleSelectorHandle(e)
              }
              style={{
                border: props.invalid
                  ? "1px solid #FF9B9B"
                  : "1px solid transparent",
              }}>
              <p className={classes.overflowP}>
                {selectedOption === ""
                  ? props.placeholder
                    ? props.placeholder
                    : t("selectOne")
                  : selectedOption}
              </p>
              {selectorOpen ? <ExpandLess /> : <ExpandMore />}
            </div>
            {selectorOpen ? (
              <div className="optionsDiv" onClick={(e) => e.stopPropagation()}>
                {options.map((o, idx) => {
                  let bool = idx === 0 ? true : false;

                  return (
                    <p
                      key={idx}
                      onMouseDown={(e) => handleOptionClick(e, bool)}>
                      {o}
                    </p>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </ClickAwayListener>
    );
  }

  return (
    <ClickAwayListener onClickAway={(e) => toggleSelector(false)}>
      <div
        style={{
          width: width,
          maxWidth: maxWidth,
          opacity: props.disabled ? 0.5 : 1,
        }}>
        {props.label ? <p className={classes.label}>{props.label}</p> : ""}
        <div className={classes.selector}>
          <div
            className={`selected ${props.invalid ? "invalidSelector" : ""}`}
            onClick={props.disabled ? () => {} : (e) => toggleSelectorHandle(e)}
            style={{
              borderRadius: 4,
            }}>
            <p className={classes.overflowP}>
              {selectedOption === ""
                ? props.placeholder
                  ? props.placeholder
                  : t("selectOne")
                : selectedOption}
            </p>
            {selectorOpen ? <ExpandLess /> : <ExpandMore />}
          </div>
          {selectorOpen ? (
            <div className="optionsDiv">
              <input
                type="text"
                onChange={(e) => filterOptions(e)}
                placeholder={t("searchLabel")}
                onFocus={() => handleInputFocus()}
                onBlur={() => handleInputFocus()}
                value={query}
                ref={inputRef}
              />
              {onSearch
                ? filteredOptions.map((o, idx) => (
                    <p
                      key={idx}
                      className={classes.overflowP2}
                      onMouseDown={(e) => handleOptionClick(e, o)}>
                      {o}
                    </p>
                  ))
                : options.map((o, idx) => (
                    <p
                      key={idx}
                      className={classes.overflowP2}
                      onMouseDown={(e) => handleOptionClick(e, o)}>
                      {o}
                    </p>
                  ))}

              {/* {options.map((o, idx) => (
              <p key={idx} onMouseDown={(e) => handleOptionClick(e, o)}>
                {o}
              </p>
            ))} */}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </ClickAwayListener>
  );
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

const styles = (theme) => ({
  label: {
    color: theme.colors.text.secondary,
    fontSize: 12,
    marginBottom: 4,
  },
  overflowP: {
    width: "70% !important",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  overflowP2: {
    width: "100% !important",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  selector: {
    height: 50,
    background: theme.colors.background.inactive,
    borderRadius: 4,
    // boxShadow: theme.defaults.shadow,
    position: "relative",
    "& .selected": {
      height: "100%",
      width: "100%",
      display: "flex",
      alignItems: "center",
      position: "relative",
      border: "1px solid transparent",
      "&.invalidSelector": {
        borderColor: theme.colors.buttons.sell,
      },
      "& p": {
        marginLeft: 16,
        marginBottom: 0,
        height: "100%",
        display: "flex",
        alignItems: "center",
      },
      "& svg": {
        position: "absolute",
        top: "25%",
        right: 8,
      },
    },
    "& .optionsDiv": {
      background: theme.colors.background.inactive,
      borderRadius: 4,
      boxShadow: theme.defaults.shadow,
      padding: "16px 0",
      position: "absolute",
      top: 55,
      width: "100%",
      zIndex: 1000,
      maxHeight: 200,
      overflowY: "auto",
      "& input": {
        marginLeft: 8,
        paddingBottom: 4,
        marginBottom: 4,
        background: "none",
        border: "none",
        color: theme.colors.text.secondary,
        width: "95% !important",
        // fontFamily: "Titillium Web",
        height: "auto !important",
        boxShadow: "none !important",
        borderBottom: `1px solid ${theme.colors.misc.dividers} !important`,
        paddingLeft: "0 !important",
        borderRadius: "0 !important",
      },

      "& p": {
        fontSize: 12,
        height: 30,
        cursor: "pointer",
        transition: ".3s",
        padding: "0 16px 0 8px",
        marginBottom: 0,
        display: "flex",
        alignItems: "center",
        "&:hover": {
          background: theme.colors.background.active,
          color: theme.colors.text.textOnRed,
        },
        "&:first-of-type": {
          marginTop: 0,
        },
        "&:last-of-type": {
          marginBottom: 0,
        },
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Selector2))
);
